import { useState } from 'react'
import { Link, router, usePage } from '@inertiajs/react'
import { Button } from '@/components/ui/Button'

interface Props {
  errors?: string[]
  notice?: string
}

export default function ForgotPassword() {
  const { props } = usePage<Props>()
  const [email, setEmail] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    router.post('/users/password', { user: { email } })
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="h-14 flex items-center px-6">
        <Link href="/" className="font-bold text-xl text-gray-900">GetCasts</Link>
      </header>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl border border-gray-200 p-8 w-full max-w-md shadow-sm">
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Forgot your password?</h1>
          <p className="text-sm text-gray-500 mb-6">
            Enter your email and we'll send you a reset link.
          </p>

          {props.notice && (
            <div className="mb-4 rounded-xl bg-green-50 border border-green-200 px-4 py-3 text-sm text-green-700">
              {props.notice}
            </div>
          )}

          {props.errors && props.errors.length > 0 && (
            <div className="mb-4 rounded-xl bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
              {props.errors[0]}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand/30"
              />
            </div>
            <Button className="w-full rounded-xl py-2.5" type="submit">
              Send reset link
            </Button>
          </form>

          <p className="text-sm text-center text-gray-500 mt-4">
            Remembered it?{' '}
            <Link href="/users/sign_in" className="text-brand font-medium hover:underline">
              Sign in →
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
